import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./aplicacion/aplicacion.module').then((m) => m.AplicacionModule),
  },
  {
    path: 'reservations',
    loadChildren: () =>
      import('./pages/reservations/reservations.module').then(
        (m) => m.ReservationsModule,
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'profile-new',
    loadChildren: () =>
      import('./pages/profile-new/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'wallet',
    loadChildren: () =>
      import('./pages/wallet/wallet.module').then((m) => m.WalletModule),
  },
  {
    path: 'marketplace',
    loadChildren: () =>
      import('./pages/marketplace/marketplace.module').then((m) => m.MarketplaceModule),
  },
  {
    path: 'referral',
    loadChildren: () =>
      import('./pages/referral-onboarding/referral-onboarding.module').then(
        (m) => m.ReferralOnboardingModule,
      ),
  },
  {
    path: 'reservation-attendance',
    loadChildren: () =>
      import('./pages/reservation-attendance/reservation-attendance.module').then(
        (m) => m.ReservationAttendanceModule,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
})
export class AppRoutingModule {}
